import { ApiError } from './api-error'

/** No payload or parser cause escapes this boundary: replies may contain private records. */
export const INVALID_RESPONSE_MESSAGE =
  'Scrambl returned an unreadable response. Refresh to check the latest state.'

export class InvalidJsonResponseError extends ApiError {
  constructor(status: number) {
    super(INVALID_RESPONSE_MESSAGE, status, {
      code: 'INVALID_API_RESPONSE',
      message: INVALID_RESPONSE_MESSAGE,
    })
    this.name = 'InvalidJsonResponseError'
  }
}

/** Decode the actual body once. Headers cannot turn a nonempty reply into an acknowledgement. */
export async function readJsonResponse<T>(response: Response): Promise<T> {
  // Read failures remain transport failures; only malformed JSON gets a private protocol error.
  const text = await response.text()
  // Existing Nest handlers returning null/void send a genuinely empty body.
  if (text === '') return { success: true } as T
  try {
    return JSON.parse(text) as T
  } catch {
    throw new InvalidJsonResponseError(response.status)
  }
}
